// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen",
    "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue",
    sans-serif;
  margin: 0;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

* {
  scrollbar-width: auto;
  scrollbar-color: #32534850 #5d5d5d7e;
  font-family: Roboto, sans-serif;
  height: auto;
}

*::-webkit-scrollbar {
  width: 12px;
}

*::-webkit-scrollbar-track {
  background: #3b5e4410;
  border-radius: 10px;
}

*::-webkit-scrollbar-thumb {
  background-color: #5d5d5d7e;
  border-radius: 25px;
  border: 1px solid #3b5e4410;
}

*::-webkit-scrollbar-thumb:hover {
  background: #2828287e;
  box-shadow: 0 0 2px 1px rgba(0, 0, 0, 0.2);
}

*::-webkit-scrollbar-thumb:active {
  background: #0000007e;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, "Courier New",
    monospace;
}

.swal2-success-line-tip,
.swal2-success-line-long {
  font-size: 14px !important;
}

.swal2-x-mark-line-right,
.swal2-x-mark-line-left {
  font-size: 14px !important;
}

.MuiPickersCalendarHeader-label {
  text-transform: capitalize;
}

.swal2-container {
  z-index: 999999 !important;
}

html {
  font-size: 14px;
}

@media (max-width: 1280px) and (max-height: 720px) {
  html {
    font-size: 12px;
  }
}

@media (min-width: 1440px) and (min-height: 900px) {
  html {
    font-size: 20px;
  }
}

@media (min-width: 1920px) and (min-height: 1080px) {
  html {
    font-size: 22px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE;;cAEY;EACZ,SAAS;EACT,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,qBAAqB;EACrB,oCAAoC;EACpC,+BAA+B;EAC/B,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;EACrB,0CAA0C;AAC5C;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE;aACW;AACb;;AAEA;;EAEE,0BAA0B;AAC5B;;AAEA;;EAEE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF","sourcesContent":["body {\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\",\n    \"Ubuntu\", \"Cantarell\", \"Fira Sans\", \"Droid Sans\", \"Helvetica Neue\",\n    sans-serif;\n  margin: 0;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n* {\n  scrollbar-width: auto;\n  scrollbar-color: #32534850 #5d5d5d7e;\n  font-family: Roboto, sans-serif;\n  height: auto;\n}\n\n*::-webkit-scrollbar {\n  width: 12px;\n}\n\n*::-webkit-scrollbar-track {\n  background: #3b5e4410;\n  border-radius: 10px;\n}\n\n*::-webkit-scrollbar-thumb {\n  background-color: #5d5d5d7e;\n  border-radius: 25px;\n  border: 1px solid #3b5e4410;\n}\n\n*::-webkit-scrollbar-thumb:hover {\n  background: #2828287e;\n  box-shadow: 0 0 2px 1px rgba(0, 0, 0, 0.2);\n}\n\n*::-webkit-scrollbar-thumb:active {\n  background: #0000007e;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, \"Courier New\",\n    monospace;\n}\n\n.swal2-success-line-tip,\n.swal2-success-line-long {\n  font-size: 14px !important;\n}\n\n.swal2-x-mark-line-right,\n.swal2-x-mark-line-left {\n  font-size: 14px !important;\n}\n\n.MuiPickersCalendarHeader-label {\n  text-transform: capitalize;\n}\n\n.swal2-container {\n  z-index: 999999 !important;\n}\n\nhtml {\n  font-size: 14px;\n}\n\n@media (max-width: 1280px) and (max-height: 720px) {\n  html {\n    font-size: 12px;\n  }\n}\n\n@media (min-width: 1440px) and (min-height: 900px) {\n  html {\n    font-size: 20px;\n  }\n}\n\n@media (min-width: 1920px) and (min-height: 1080px) {\n  html {\n    font-size: 22px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
